import { render, staticRenderFns } from "./Cytology_EachID.vue?vue&type=template&id=42d65b20&scoped=true"
import script from "./Cytology_EachID.vue?vue&type=script&lang=js"
export * from "./Cytology_EachID.vue?vue&type=script&lang=js"
import style0 from "./Cytology_EachID.vue?vue&type=style&index=0&id=42d65b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d65b20",
  null
  
)

export default component.exports